// src/features/engine/context/TaskRuntimeContext.jsx

import { createContext, useContext } from "react";

const TaskRuntimeContext = createContext(null);

export function TaskRuntimeProvider({
  session,
  step,
  program,
  task,
  responses,
  apiUrl,
  token,
  completeCurrentStep,
  navigateToProgramDashboard,
  navigateToProgramStep,
  refetchProgramState,
  backPath,
  programScopedLocale,
  advanceStandaloneSession,
  onStandaloneComplete,
  stimulusSelectionControl,
  referenceFeedbackEnabled = true,
  onRuntimeSubmitted,
  assignmentId,
  participantMediaContext,
  temporalDelivery,
  participantTimeZone,
  children
}) {
  return (
    <TaskRuntimeContext.Provider
      value={{
        session,
        step,
        program,
        task,
        responses,
        apiUrl,
        token,
        completeCurrentStep,
        navigateToProgramDashboard,
        navigateToProgramStep,
        refetchProgramState,
        backPath,
        programScopedLocale,
        advanceStandaloneSession,
        onStandaloneComplete,
        stimulusSelectionControl,
        referenceFeedbackEnabled,
        onRuntimeSubmitted,
        assignmentId,
        participantMediaContext,
        temporalDelivery,
        participantTimeZone
      }}
    >
      {children}
    </TaskRuntimeContext.Provider>
  );
}

export function useTaskRuntime() {
  const context = useContext(TaskRuntimeContext);

  if (!context) {
    throw new Error(
      "useTaskRuntime must be used within a TaskRuntimeProvider"
    );
  }

  return context;
}

export function useOptionalTaskRuntime() {
  return useContext(TaskRuntimeContext);
}
